import PropTypes from 'prop-types';
import React from 'react';
import { RangeBoundaries } from '~/modules/common/charts/timeline/components';
import { useHasFeatureFlag } from '~/modules/common/hooks';
import ResourceRequestBlockGroup from '../ResourceRequestBlockGroup';
import ResourceRequestBlockGroup2 from '../ResourceRequestBlockGroup/ResourceRequestBlockGroup2';

export const ResourceRequestChartTimeLineRow = ({
  scale,
  chartDates,
  startDate,
  endDate,
  chartDisplayDateRange,
  resourceRequest,
  isResourceRequestReadOnly,
  showUserAssignmentColumn,
  resourceAllocations,
  canViewCostData,
  isEditSwitchEnabled,
  displayUnit,
  dynamicContainerHeight
}) => {
  const [{ start: chartStartDate }] = chartDates;

  const isPsaRmpUserSchedulePerfFixEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaRmpUserSchedulePerfFixEnabled'
  });

  return (
    <>
      <RangeBoundaries
        chartStartDate={chartStartDate}
        scale={scale}
        start={startDate}
        end={endDate}
      />
      {isPsaRmpUserSchedulePerfFixEnabled ? (
        <ResourceRequestBlockGroup2
          resourceRequest={resourceRequest}
          chartDates={chartDates}
          scale={scale}
          isEditSwitchEnabled={isEditSwitchEnabled}
          resourceAllocations={resourceAllocations}
          showUserAssignmentColumn={showUserAssignmentColumn}
          chartDisplayDateRange={chartDisplayDateRange}
          displayUnit={displayUnit}
          dynamicContainerHeight={dynamicContainerHeight}
        />
      ) : (
        <ResourceRequestBlockGroup
          resourceRequest={resourceRequest}
          chartDates={chartDates}
          scale={scale}
          isEditSwitchEnabled={isEditSwitchEnabled}
          resourceAllocations={resourceAllocations}
          isResourceRequestReadOnly={isResourceRequestReadOnly}
          showUserAssignmentColumn={showUserAssignmentColumn}
          chartDisplayDateRange={chartDisplayDateRange}
          canViewCostData={canViewCostData}
          displayUnit={displayUnit}
          dynamicContainerHeight={dynamicContainerHeight}
        />
      )}
    </>
  );
};

ResourceRequestChartTimeLineRow.propTypes = {
  scale: PropTypes.string.isRequired,
  chartDates: PropTypes.array,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  isResourceRequestReadOnly: PropTypes.bool,
  resourceAllocations: PropTypes.array,
  isEditSwitchEnabled: PropTypes.bool,
  chartDisplayDateRange: PropTypes.object.isRequired,
  showUserAssignmentColumn: PropTypes.bool,
  canViewCostData: PropTypes.bool,
  displayUnit: PropTypes.string,
  dynamicContainerHeight: PropTypes.number
};

export default ResourceRequestChartTimeLineRow;
